import includes from "lodash/includes";
import uniq from "lodash/uniq";
import { createSelector } from "reselect";

const currentUserCompanySelector = (state) => state.currentUser.company;
const portfoliosSelector = (state) => state.portfolios;
const selectedPortfolioIDsSelector = (state) => state.selectedPortfolioIDs;

export const selectedPortfoliosSelector = createSelector(
  portfoliosSelector,
  selectedPortfolioIDsSelector,
  (portfolios, selectedPortfolioIDs) =>
    portfolios.filter((p) => includes(selectedPortfolioIDs, p.id))
);

export const nonFakePortfoliosSelector = createSelector(portfoliosSelector, (portfolios) =>
  portfolios.filter((p) => !p.fake)
);

export const ownerPortfoliosSelector = createSelector(
  currentUserCompanySelector,
  portfoliosSelector,
  (currentUserCompany, portfolios) =>
    portfolios.filter((p) => !p.fake && p.company.id === currentUserCompany.id)
);

export const ownerPortfoliosSelectorWithPermission = (permission) =>
  createSelector(ownerPortfoliosSelector, (portfolios) =>
    portfolios.filter((p) => p.limitations.indexOf(permission) < 0)
  );

export const ownerPortfoliosWithAssetsSelector = createSelector(
  ownerPortfoliosSelector,
  (portfolios) => portfolios.filter((p) => !!p.totalAssets)
);

export const selectedPortfolioSelector = createSelector(
  selectedPortfoliosSelector,
  (selectedPortfolios) => (selectedPortfolios.length === 1 ? selectedPortfolios[0] : undefined)
);

export const selectedOwnerPortfolioSelectorWithPermission = (permission) =>
  createSelector(
    selectedPortfolioSelector,
    currentUserCompanySelector,
    (selectedPortfolio, currentUserCompany) =>
      selectedPortfolio &&
      selectedPortfolio.company.id === currentUserCompany.id &&
      selectedPortfolio.limitations.indexOf(permission) < 0
        ? selectedPortfolio
        : undefined
  );

// const stages = [
//   { 1: "prospects", 2: "touring" },
//   { 1: "other_stage", 2: "touring" },
// ];

// const result = { 1: ["prospects", "other_stage"], 2: ["touring"] };

export const dealStagesSelector = createSelector(
  selectedPortfoliosSelector,
  (selectedPortfolios) => {
    const portfolioStages = selectedPortfolios
      .map((portfolio) => portfolio.dealStages)
      .filter(Boolean);

    return portfolioStages.reduce(
      (stageObject, stages) =>
        Object.keys(stages).reduce(
          (acc, key) => ({
            ...acc,
            [key]: acc[key] ? uniq([...acc[key], stages[key]]) : [stages[key]],
          }),
          stageObject
        ),
      {}
    );
  }
);

export const hasExtraProspectsColumn = createSelector(dealStagesSelector, (dealStages) => {
  const stages = Object.values(dealStages || {});

  return stages.length > 4 && stages[0] && stages[0][0] === "prospects";
});

export default selectedPortfoliosSelector;
